import React from "react";

// Instead of a white page when something breaks: a short message and a
// Reload button; the error goes to our server log so we see the real cause.
// (What an author typed in the submit form is kept: shared/lib/formDraft.)

const report = (error, info) => {
  try {
    const body = JSON.stringify({
      message: String(error?.message || error || "").slice(0, 500),
      name: String(error?.name || "").slice(0, 80),
      stack: String(error?.stack || "").slice(0, 2000),
      component: String(info?.componentStack || "").slice(0, 1200),
      url: window.location.pathname + window.location.search,
    });
    const url = `${process.env.REACT_APP_SERVER_BASE_URL || ""}/client-errors`;
    if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }));
    else fetch(url, { method: "POST", headers: { "Content-Type": "text/plain" }, body, keepalive: true }).catch(() => {});
  } catch (e) {
    // reporting must never break the page
  }
};

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    report(error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "#f4f4f6", fontFamily: "Inter, Arial, sans-serif" }}>
        <div style={{ maxWidth: 420, padding: "32px 28px", borderRadius: 16, background: "#fff", textAlign: "center", boxShadow: "0 2px 10px rgba(17,17,20,.06)" }}>
          <h1 style={{ margin: "0 0 10px", fontSize: 22, fontWeight: 800, color: "#111114" }}>Something went wrong</h1>
          <p style={{ margin: "0 0 20px", color: "#6b6b70", fontSize: 15, lineHeight: 1.55 }}>
            Please reload the page. If you were filling in a form, what you typed is kept; you may need to choose your video again.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ height: 44, padding: "0 26px", border: 0, borderRadius: 100, background: "#fe0160", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer" }}
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
